import React from 'react'
import PropTypes from 'prop-types'
import { Label, TextArea } from '../tools'

function StoryCard({ setting }) {
  const { label, text, isLoading, textEdit } = setting

  return (
    <div className="col">
      <div className="inner shadow-block position-relative">
        {label && (
          <Label
            setting={{
              label: '',
              title: label,
              edit: true,
            }}
          />
        )}
        {isLoading ? (
          <Loading setting={{}} />
        ) : (
          <div style={{ marginLeft: '-20px', marginRight: '-20px' }}>
            <TextArea
              setting={{
                label: '',
                value: text,
                textEdit,
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

function Loading({ setting }) {
  const { style } = setting

  if (style === 'one') {
    return (
      <div className="loading-wrap">
        <div className="loading-bar">loading</div>
      </div>
    )
  }

  return (
    <div className="loading-wrap">
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar mb-4">loading</div>
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar mb-4">loading</div>
      <div className="loading-bar mb-2">loading</div>
      <div className="loading-bar">loading</div>
    </div>
  )
}

StoryCard.propTypes = {
  setting: PropTypes.shape().isRequired,
}

Loading.propTypes = {
  setting: PropTypes.shape().isRequired,
}

export default StoryCard
